module.exports = __webpack_public_path__ + "files/95ecd65de316c35dd14a7f837043cda2.png";